import { useLevelGeometry } from '@hooks'
import { useGameStore } from '@stores'
import { getWorldPosition } from '@utils'

import { BallastMergedManager } from './BallastMergedManager'
import { RailsMergedManager } from './RailsMergedManager'
import { SplinesInstancedManager } from './SplinesInstancedManager'
import { TrackCell } from './TrackCell'

export function Track() {
  const network = useGameStore(state => state.network)
  const { cellGeometries, splineInstances, railInstances, ballastInstances, size } =
    useLevelGeometry()
  const cells = Array.from(network.cells.values())

  return (
    <>
      <BallastMergedManager instances={ballastInstances} />
      <SplinesInstancedManager instances={splineInstances} />
      <RailsMergedManager instances={railInstances} />

      {cells.map(cell => {
        const position = getWorldPosition(cell.x, cell.y, size.fullWidth, size.height)
        const curves = cellGeometries.get(cell.id)?.curves ?? []
        return <TrackCell key={cell.id} position={position} curves={curves} {...cell} />
      })}
    </>
  )
}
